import React from 'react';
import { DashboardManagement } from '@/components/settings/DashboardManagement';

const DashboardSettings = () => {
  return (
    <div className="container mx-auto py-6">
      <DashboardManagement />
    </div>
  );
};

export default DashboardSettings;